import { Alert } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { TbInfoTriangle } from "react-icons/tb";

import CommonAlert from "@/components/CommonAlert";
import { useDeleteUserMutation } from "@/requests/user.mutations";
import { useUsersTableActions, useUsersTableDeletionInfo } from "@/stores/use-users-table";
import { UserType } from "@/types/user.types";

function UserDeleteDialog() {
    const { t } = useTranslation();
    const { mutateAsync, isPending } = useDeleteUserMutation();

    const deletionInfo = useUsersTableDeletionInfo();
    const { updateDeletionInfo } = useUsersTableActions();
    const handleConfirm = async () => {
        if (isPending || !deletionInfo) return;
        try {
            const res = await mutateAsync(deletionInfo);
            enqueueSnackbar(t(res.message || ""), { variant: "success" });
        } catch (error) {
            console.error("IsDeletion error:", error);
        }
        handleClose();
    };
    const handleClose = () => {
        updateDeletionInfo(null);
    };

    return (
        <CommonAlert
            open={!!deletionInfo}
            loading={isPending}
            description="confirmations.deleteUser"
            color="error"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                name: deletionInfo?.name || "",
            }}
        >
            {deletionInfo?.userType === UserType.DRIVER && (
                <Alert icon={<TbInfoTriangle />} className="mt-2" severity="error">
                    {t("infos.driverWillBeRemoved")}
                </Alert>
            )}
        </CommonAlert>
    );
}

export default UserDeleteDialog;
